@import "@atc/axl-atc/scss/bootstrap-extensions/glyphicons";
@import "@atc/axl-atc/scss/bootstrap-extensions/glyphicon-stack";

// center carousel arrow icons
.glyphicon:not(.form-control-feedback) {
    @include icon;
    top: 1.5px;

    &.glyphicon-menu-left{
        right: 1px;
    }
    &.glyphicon-menu-right {
        left: 1px;
    }
}